import { X } from 'lucide-react';

export function Modal({ title, description, open, onClose, children, className = '', closeDisabled = false }) {
  if (!open) return null;

  return (
    <div className="modal-backdrop" role="presentation">
      <section className={`modal ${className}`.trim()} role="dialog" aria-modal="true" aria-labelledby="modal-title">
        <div className="modal-header">
          <div>
            <h2 id="modal-title">{title}</h2>
            {description ? <p>{description}</p> : null}
          </div>
          <button className="icon-button" type="button" onClick={onClose} disabled={closeDisabled} aria-label={closeDisabled ? 'Payment confirmation in progress' : 'Close modal'}>
            <X size={18} />
          </button>
        </div>
        {children}
      </section>
    </div>
  );
}
